import React from 'react';
import { ThemedText } from '../../../components';
import { parseTagList } from '../parsers';

export default function TagListValue({ value, emptyValue = '—', theme }) {
  const tags = parseTagList(value);
  if (tags.length === 0) {
    return <ThemedText style={{ color: theme?.colors?.muted }}>{emptyValue}</ThemedText>;
  }
  return <ThemedText>{tags.join(', ')}</ThemedText>;
}
